import useUser from "context/UserCustomer/useUserCustomerContext";

const useLoan = () => {
  const { loan, refetchLoan: refetch } = useUser();

  return { loan, refetch };
};

export default useLoan;
